webpackJsonp([86],{

/***/ 696:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mastodon_load_polyfills__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mastodon_ready__ = __webpack_require__(63);




window.addEventListener('message', function (e) {
  var data = e.data || {};

  if (!window.parent || data.type !== 'setHeight') {
    return;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__mastodon_ready__["default"])(function () {
    window.parent.postMessage({
      type: 'setHeight',
      id: data.id,
      height: document.getElementsByTagName('html')[0].scrollHeight
    }, '*');
  });
});

function main() {
  var _require = __webpack_require__(99),
      length = _require.length;

  var IntlRelativeFormat = __webpack_require__(77).default;

  var _require2 = __webpack_require__(153),
      delegate = _require2.delegate;

  var emojify = __webpack_require__(74).default;

  var _require3 = __webpack_require__(6),
      getLocale = _require3.getLocale;

  var _getLocale = getLocale(),
      localeData = _getLocale.localeData;

  var React = __webpack_require__(0);
  var ReactDOM = __webpack_require__(20);

  localeData.forEach(IntlRelativeFormat.__addLocaleData);

  Object(__WEBPACK_IMPORTED_MODULE_2__mastodon_ready__["default"])(function () {
    var locale = document.documentElement.lang;

    var dateTimeFormat = new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric'
    });

    var relativeFormat = new IntlRelativeFormat(locale);

    [].forEach.call(document.querySelectorAll('.emojify'), function (content) {
      content.innerHTML = emojify(content.innerHTML);
    });

    [].forEach.call(document.querySelectorAll('time.formatted'), function (content) {
      var datetime = new Date(content.getAttribute('datetime'));
      var formattedDate = dateTimeFormat.format(datetime);

      content.title = formattedDate;
      content.textContent = formattedDate;
    });

    [].forEach.call(document.querySelectorAll('time.time-ago'), function (content) {
      var datetime = new Date(content.getAttribute('datetime'));

      content.title = dateTimeFormat.format(datetime);
      content.textContent = relativeFormat.format(datetime);
    });

    [].forEach.call(document.querySelectorAll('.logo-button'), function (content) {
      content.addEventListener('click', function (e) {
        e.preventDefault();
        window.open(e.target.href, 'mastodon-intent', 'width=445,height=600,resizable=no,menubar=no,status=no,scrollbars=yes');
      });
    });

    var reactComponents = document.querySelectorAll('[data-component]');
    if (reactComponents.length > 0) {
      __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 859)).then(function (_ref) {
        var MediaContainer = _ref.default;

        var content = document.createElement('div');

        ReactDOM.render(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(MediaContainer, {
          locale: locale,
          components: reactComponents
        }), content);
        document.body.appendChild(content);
      }).catch(function (error) {
        return console.error(error);
      });
    }
  });

  delegate(document, '.webapp-btn', 'click', function (_ref2) {
    var target = _ref2.target,
        button = _ref2.button;

    if (button !== 0) {
      return true;
    }
    window.location.href = target.href;
    return false;
  });

  delegate(document, '.status__content__spoiler-link', 'click', function (_ref3) {
    var target = _ref3.target;

    var contentEl = target.parentNode.parentNode.querySelector('.e-content');

    if (contentEl.style.display === 'block') {
      contentEl.style.display = 'none';
      target.parentNode.style.marginBottom = 0;
    } else {
      contentEl.style.display = 'block';
      target.parentNode.style.marginBottom = null;
    }

    return false;
  });

  delegate(document, '.account_display_name', 'input', function (_ref4) {
    var target = _ref4.target;

    var nameCounter = document.querySelector('.name-counter');

    if (nameCounter) {
      nameCounter.textContent = 30 - length(target.value);
    }
  });

  delegate(document, '.account_note', 'input', function (_ref5) {
    var target = _ref5.target;

    var noteCounter = document.querySelector('.note-counter');

    if (noteCounter) {
      noteCounter.textContent = 160 - length(target.value);
    }
  });

  delegate(document, '#account_avatar', 'change', function (_ref6) {
    var target = _ref6.target;

    var avatar = document.querySelector('.card.compact .avatar img');

    var _ref7 = target.files || [],
        file = _ref7[0];

    var url = file ? URL.createObjectURL(file) : avatar.dataset.originalSrc;

    avatar.src = url;
  });

  delegate(document, '#account_header', 'change', function (_ref8) {
    var target = _ref8.target;

    var header = document.querySelector('.card.compact');

    var _ref9 = target.files || [],
        file = _ref9[0];

    var url = file ? URL.createObjectURL(file) : header.dataset.originalSrc;

    header.style.backgroundImage = 'url(' + url + ')';
  });
}

Object(__WEBPACK_IMPORTED_MODULE_1__mastodon_load_polyfills__["a" /* default */])().then(main).catch(function (error) {
  console.error(error);
});

/***/ })

},[696]);


// WEBPACK FOOTER //
// public-472228f2442a8b4c1f2c.js